import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentSocialLinksDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-social-links-display',
  imports: [MatIconModule],
  templateUrl: './agent-social-links-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSocialLinksDisplayComponent {
  readonly socialLinks = input<AgentSocialLinksDto | undefined>(undefined);

  readonly hasSocialLinks = computed(() => {
    const l = this.socialLinks();
    if (!l) return false;
    return Boolean(l.website || l.googleReviewUrl || l.opinionSystemUrl || l.linkedin);
  });
}
